/**
 * Debounces calls to a function by debouncing a function call to only fire when a provided amount of time has elapsed
 *
 * @param delay Time (in ms) that should
 * @param callback Function to call when debounce is complete
 */
export const debounce = (delay, callback) => {
    // Timeout identifier used for debouncing
    let timeoutId;
    // The function that will actually be called
    return function debounceFn(...args) {
        // If function is called before timeout fires, then the timeout needs to be cleared and reset
        clearTimeout(timeoutId);
        // Reset the timer for firing the function
        timeoutId = setTimeout(() => callback.apply(this, args), delay);
    };
};
